<!-- Global PrimeNG Components -->
<p-toast></p-toast>
<p-toast key="center" position="center"></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-text"></p-confirmDialog>

<!-- Anonymous print route - skip all auth UI -->
@if (isPrintRoute()) {
    <router-outlet />
}

@if (!isPrintRoute() && (authenticationLoading() || userLoading())) {
    <app-sign-in-loader />
}
@if (!isPrintRoute() && isAuthenticated() && !authenticationLoading() && !userLoading() && userHasNoCompanies()) {
    <app-account-no-companies />
}
@if (!isPrintRoute() && isAuthenticated() && !authenticationLoading() && !userLoading() && !userHasNoCompanies()) {
    <div class="core-container">
        <!-- LEFT SIDEBAR -->
        <app-side-navigation />

        <!-- MAIN AREA (toolbar + content) -->
        <div class="core-main-area">
            <!-- TOOLBAR -->
            <app-navigation-header />

            <!-- MAIN CONTENT -->
            <main class="core-content">
                @if (!hasNavigated()) {
                    <div class="core-content__skeleton">
                        <p-skeleton width="40%" height="2rem" styleClass="core-content__skeleton-row" />
                        <p-skeleton width="100%" height="1.5rem" styleClass="core-content__skeleton-row" />
                        <p-skeleton width="80%" height="1.5rem" styleClass="core-content__skeleton-row" />
                        <p-skeleton width="100%" height="12rem" styleClass="core-content__skeleton-row" />
                        <p-skeleton width="100%" height="12rem" styleClass="core-content__skeleton-row" />
                    </div>
                }
                <!-- BREADCRUMB (scrolls with content) -->
                <app-breadcrumb />
                <router-outlet />
            </main>
        </div>

        <!-- SETTINGS DRAWER (left side, next to sidebar) -->
        <p-drawer
            #drawer
            [visible]="settingsDrawerVisible()"
            (visibleChange)="onDrawerVisibleChange($event)"
            position="left"
            [modal]="true"
            [style]="{ width: '400px' }"
            styleClass="yllw-drawer">
            <ng-template #header>
                <span class="drawer-header-title">{{ 'SETTINGS.TITLE' | translate }}</span>
            </ng-template>
            <app-settings-drawer />
        </p-drawer>
    </div>
}
